__turbopack_context__.v({
  "active": "VerticalSlider-module__vedu-G__active",
  "cardHover": "VerticalSlider-module__vedu-G__cardHover",
  "contentCard": "VerticalSlider-module__vedu-G__contentCard",
  "contentGrid": "VerticalSlider-module__vedu-G__contentGrid",
  "fadeIn": "VerticalSlider-module__vedu-G__fadeIn",
  "fadeInAnimation": "VerticalSlider-module__vedu-G__fadeInAnimation",
  "imageContainer": "VerticalSlider-module__vedu-G__imageContainer",
  "inactive": "VerticalSlider-module__vedu-G__inactive",
  "lgOrderFirst": "VerticalSlider-module__vedu-G__lgOrderFirst",
  "lgOrderSecond": "VerticalSlider-module__vedu-G__lgOrderSecond",
  "navButton": "VerticalSlider-module__vedu-G__navButton",
  "navigationButtons": "VerticalSlider-module__vedu-G__navigationButtons",
  "orderFirst": "VerticalSlider-module__vedu-G__orderFirst",
  "orderSecond": "VerticalSlider-module__vedu-G__orderSecond",
  "slideActive": "VerticalSlider-module__vedu-G__slideActive",
  "slideInactive": "VerticalSlider-module__vedu-G__slideInactive",
  "slideItem": "VerticalSlider-module__vedu-G__slideItem",
  "sliderContainer": "VerticalSlider-module__vedu-G__sliderContainer",
  "sliderWrapper": "VerticalSlider-module__vedu-G__sliderWrapper",
});
